import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Redirects non-admin users to /jobs.
 * Returns { isAdmin, isLoading } so pages can show a loading state.
 */
export function useRequireAdmin() {
  const { profile, isLoading } = useAuth();
  const navigate = useNavigate();

  const isAdmin = profile?.role === "admin";

  useEffect(() => {
    if (!isLoading && !isAdmin) {
      navigate("/jobs", { replace: true });
    }
  }, [isLoading, isAdmin, navigate]);

  return { isAdmin, isLoading };
}
